import { render, staticRenderFns } from "./mechanism.vue?vue&type=template&id=83565cea&scoped=true&"
import script from "./mechanism.vue?vue&type=script&lang=ts&"
export * from "./mechanism.vue?vue&type=script&lang=ts&"
import style0 from "./mechanism.vue?vue&type=style&index=0&id=83565cea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83565cea",
  null
  
)

export default component.exports